import API from "../../../../../../global/api";

//GET ALL CALL

export const requestAllAssetDebitData = (data) => {
    return {
      type: "RESPONDENT_REQUEST_ALL_ASSET_DEBIT_DATA",
    };
  };
  export const successAllAssetDebitData = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_ALL_ASSET_DEBIT_DATA",
      payload: data,
    };
  };
  export const errorAllAssetDebitData = () => {
    return {
      type: "RESPONDENT_ERROR_ALL_ASSET_DEBIT_DATA"
    };
  };
  
  export const allAssetDebitData = (data) => {
    return (dispatch) => {
      dispatch(requestAllAssetDebitData(data))
      API.post(`/assetDebitRes/get-all-form-data`,data).then((res) => {
         let data1 = [];
         data1 = res.data;
        dispatch(successAllAssetDebitData(data1));
      }).catch(err => {
        dispatch(errorAllAssetDebitData());
      })
    };
  };



//POST CALL

export const requestAssetDebitData = (data) => {
    return {
      type: "RESPONDENT_REQUEST_ASSET_DEBIT_DATA",
    };
  };
  export const successAssetDebitData = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_ASSET_DEBIT_DATA",
      payload: data,
    };
  };
  export const errorAssetDebitData = (data) => {
    return {
      type: "RESPONDENT_ERROR_ASSET_DEBIT_DATA",
      payload: data,
    };
  };
  
  export const postAssetDebitData = (data) => {
    return (dispatch) => {
      API.post(`/assetDebitRes/postAssetDebitData`, data).then((res) => {
        dispatch(successAssetDebitData(data));
      });
    };
  };

//EMPLOYEMENT_DETAILS

export const requestEmployementDetails = (data) => {
    return {
      type: "RESPONDENT_REQUEST_EMPLOYEMENT_DETAILS",
    };
  };
  export const successEmployementDetails = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_EMPLOYEMENT_DETAILS",
      payload: data,
    };
  };
  export const errorEmployementDetails = (data) => {
    return {
      type: "RESPONDENT_ERROR_EMPLOYEMENT_DETAILS",
      payload: data,
    };
  };
  
  export const employementDetails = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/employementDetails`,data).then((res) => {
        dispatch(successEmployementDetails(data));
      });
    };
  };

  //AGE AND EDUCATION

  export const requestAgeEducation = (data) => {
    return {
      type: "RESPONDENT_REQUEST_AGE_EDUCATION",
    };
  };
  export const successAgeEducation = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_AGE_EDUCATION",
      payload: data,
    };
  };
  export const errorAgeEducation = (data) => {
    return {
      type: "RESPONDENT_ERROR_AGE_EDUCATION",
      payload: data,
    };
  };
  
  export const ageEducation = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/ageEducation`,data).then((res) => {
        dispatch(successAgeEducation(data));
      });
    };
  };


  //TAX INFORMATON

  export const requestTaxInformation = (data) => {
    return {
      type: "RESPONDENT_REQUEST_TAX_INFORMATION",
    };
  };
  export const successTaxInformation = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_TAX_INFORMATION",
      payload: data,
    };
  };
  export const errorTaxInformation = (data) => {
    return {
      type: "RESPONDENT_ERROR_TAX_INFORMATION",
      payload: data,
    };
  };
  
  export const taxInformation = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/taxInformation`,data).then((res) => {
        dispatch(successTaxInformation(data));
      });
    };
  };

  //OTHER PARTY INCOME
  
  export const requestOtherPartyIncome = (data) => {
    return {
      type: "RESPONDENT_REQUEST_OTHER_PARTY_INCOME",
    };
  };
  export const successOtherPartyIncome = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_OTHER_PARTY_INCOME",
      payload: data,
    };
  };
  export const errorOtherPartyIncome = (data) => {
    return {
      type: "RESPONDENT_ERROR_OTHER_PARTY_INCOME",
      payload: data,
    };
  };
  
  export const otherPartyIncome = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/otherPartyIncome`, data).then((res) => {
        dispatch(successOtherPartyIncome(data));
      });
    };
  };

  //INCOME
  
  export const requestIncome = (data) => {
    return {
      type: "RESPONDENT_REQUEST_INCOME",
    };
  };
  export const successIncome = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_INCOME",
      payload: data,
    };
  };
  export const errorIncome = (data) => {
    return {
      type: "RESPONDENT_ERROR_INCOME",
      payload: data,
    };
  };
  
  export const income = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/income`,data ).then((res) => {
        dispatch(successIncome(data));
      });
    };
  };

//Invest Income
 
export const requestInvestIncome = (data) => {
    return {
      type: "RESPONDENT_REQUEST_INVEST_INCOME",
    };
  };
  export const successInvestIncome = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_INVEST_INCOME",
      payload: data,
    };
  };
  export const errorInvestIncome = (data) => {
    return {
      type: "RESPONDENT_ERROR_INVEST_INCOME",
      payload: data,
    };
  };
  
  export const investIncome = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/investIncome`,data ).then((res) => {
        dispatch(successInvestIncome(data));
      });
    };
  };

  //Additional Income
  
export const requestAdditionalIncome = (data) => {
    return {
      type: "RESPONDENT_REQUEST_ADDITIONAL_INCOME",
    };
  };
  export const successAdditionalIncome = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_ADDITIONAL_INCOME",
      payload: data,
    };
  };
  export const errorAdditionalIncome = (data) => {
    return {
      type: "RESPONDENT_ERROR_ADDITIONAL_INCOME",
      payload: data,
    };
  };
  
  export const additionalIncome = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/additionalIncome`,data ).then((res) => {
        dispatch(successAdditionalIncome(data));
      });
    };
  };

  //Self Employeed Income

   
export const requestSelfEmployeedIncome = (data) => {
    return {
      type: "RESPONDENT_REQUEST_SELF_EMPLOYEED_INCOME",
    };
  };
  export const successSelfEmployeedIncome = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_SELF_EMPLOYEED_INCOME",
      payload: data,
    };
  };
  export const errorSelfEmployeedIncome = (data) => {
    return {
      type: "RESPONDENT_ERROR_SELF_EMPLOYEED_INCOME",
      payload: data,
    };
  };
  
  export const selfEmployeedIncome = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/selfEmployeedIncome`,data ).then((res) => {
        dispatch(successSelfEmployeedIncome(data));
      });
    };
  };

  //Change In Income
  
   
export const requestChangeInIncome = (data) => {
    return {
      type: "RESPONDENT_REQUEST_CHANGE_IN_INCOME",
    };
  };
  export const successChangeInIncome = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_CHANGE_IN_INCOME",
      payload: data,
    };
  };
  export const errorChangeInIncome = (data) => {
    return {
      type: "RESPONDENT_ERROR_CHANGE_IN_INCOME",
      payload: data,
    };
  };
  
  export const changeInIncome = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/changeInIncome`,data ).then((res) => {
        dispatch(successChangeInIncome(data));
      });
    };
  };


  //Deductions
  export const requestDeductions = (data) => {
    return {
      type: "RESPONDENT_REQUEST_DEDUCTIONS",
    };
  };
  export const successDeductions = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_DEDUCTIONS",
      payload: data,
    };
  };
  export const errorDeductions = (data) => {
    return {
      type: "RESPONDENT_ERROR_DEDUCTIONS",
      payload: data,
    };
  };
  
  export const deductions = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/deductions`,data ).then((res) => {
        dispatch(successDeductions(data));
      });
    };
  };

  //Asset

  export const requestAsset = (data) => {
    return {
      type: "RESPONDENT_REQUEST_ASSET",
    };
  };
  export const successAsset = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_ASSET",
      payload: data,
    };
  };
  export const errorAsset = (data) => {
    return {
      type: "RESPONDENT_ERROR_ASSET",
      payload: data,
    };
  };
  
  export const asset = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/asset`,data ).then((res) => {
        dispatch(successAsset(data));
      });
    };
  };

//Average Monthallay Expense


export const requestAverageMonthallyExpense = (data) => {
    return {
      type: "RESPONDENT_REQUEST_AVERAGE_MONTHALLY_EXPENSE",
    };
  };
  export const successAverageMonthallyExpense = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_AVERAGE_MONTHALLY_EXPENSE",
      payload: data,
    };
  };
  export const errorAverageMonthallyExpense = (data) => {
    return {
      type: "RESPONDENT_ERROR_AVERAGE_MONTHALLY_EXPENSE",
      payload: data,
    };
  };
  
  export const averageMonthallyExpenset = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/averageMonthallyExpenset`,data ).then((res) => {
        dispatch(successAverageMonthallyExpense(data));
      });
    };
  };

  //Attorney Fee

  export const requestAttorneyFee = (data) => {
    return {
      type: "RESPONDENT_REQUEST_ATTORNEY_FEE",
    };
  };
  export const successAttorneyFee = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_ATTORNEY_FEE",
      payload: data,
    };
  };
  export const errorAttorneyFee = (data) => {
    return {
      type: "RESPONDENT_ERROR_ATTORNEY_FEE",
      payload: data,
    };
  };
  
  export const attorneyFee = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/attorneyFee`,data ).then((res) => {
        dispatch(successAttorneyFee(data));
      });
    };
  };

  //NUMBER OF CHILDREN

export const requestNumberOfChildren = (data) => {
    return {
      type: "RESPONDENT_REQUEST_NUMBER_OF_CHILDREN",
    };
  };
  export const successNumberOfChildren = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_NUMBER_OF_CHILDREN",
      payload: data,
    };
  };
  export const errorNumberOfChildren = (data) => {
    return {
      type: "RESPONDENT_ERROR_NUMBER_OF_CHILDREN",
      payload: data,
    };
  };
  
  export const numberOfChildren = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/numberOfChildren`,data ).then((res) => {
        dispatch(successNumberOfChildren(data));
      });
    };
  };

  //CHILD HEALTH EXPENSES

export const requestChildHealthExpenses = (data) => {
    return {
      type: "RESPONDENT_REQUEST_CHILD_HEALTH_EXPENSES",
    };
  };
  export const successChildHealthExpenses = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_CHILD_HEALTH_EXPENSES",
      payload: data,
    };
  };
  export const errorChildHealthExpenses = (data) => {
    return {
      type: "RESPONDENT_ERROR_CHILD_HEALTH_EXPENSES",
      payload: data,
    };
  };
  
  export const childHealthExpenses = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/childHealthExpenses`,data ).then((res) => {
        dispatch(successChildHealthExpenses(data));
      });
    };
  };

  //Child Additional Expense

  
export const requestChildAdditionalExpenses = (data) => {
    return {
      type: "RESPONDENT_REQUEST_CHILD_ADDITIONAL_EXPENSES",
    };
  };
  export const successChildAdditionalExpenses = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_CHILD_ADDITIONAL_EXPENSES",
      payload: data,
    };
  };
  export const errorChildAdditionalExpenses = (data) => {
    return {
      type: "RESPONDENT_ERROR_CHILD_ADDITIONAL_EXPENSES",
      payload: data,
    };
  };
  
  export const childAdditionalExpenses = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/childAdditionalExpenses`,data ).then((res) => {
        dispatch(successChildAdditionalExpenses(data));
      });
    };
  };

  //Special hardship
  
  export const requestSpecialHardship = (data) => {
    return {
      type: "RESPONDENT_REQUEST_SPECIAL_HARDSHIP",
    };
  };
  export const successSpecialHardship = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_SPECIAL_HARDSHIP",
      payload: data,
    };
  };
  export const errorSpecialHardship = (data) => {
    return {
      type: "RESPONDENT_ERROR_SPECIAL_HARDSHIP",
      payload: data,
    };
  };
  
  export const specialHardship = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/specialHardship`,data ).then((res) => {
        dispatch(successSpecialHardship(data));
      });
    };
  };

  //Other Information

  export const requestOtherInformation = (data) => {
    return {
      type: "RESPONDENT_REQUEST_OTHER_INFORMATION",
    };
  };
  export const successOtherInformation = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_OTHER_INFORMATION",
      payload: data,
    };
  };
  export const errorOtherInformation = (data) => {
    return {
      type: "RESPONDENT_ERROR_OTHER_INFORMATION",
      payload: data,
    };
  };
  
  export const otherInformation = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/otherInformation`,data ).then((res) => {
        dispatch(successOtherInformation(data));
      });
    };
  };


  export const requestPeopleLive = (data) => {
    return {
      type: "RESPONDENT_REQUEST_PEOPLE_LIVE",
    };
  };
  export const successPeopleLive = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_PEOPLE_LIVE",
      payload: data,
    };
  };
  export const errorPeopleLive = (data) => {
    return {
      type: "RESPONDENT_ERROR_PEOPLE_LIVE",
      payload: data,
    };
  };
  
  export const peopleLiveCall = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/add-and-update-live-with-me`,data).then((res) => {
        dispatch(successPeopleLive(res.data));
      });
    };
  };




  export const requestInstallmentPayments = (data) => {
    return {
      type: "RESPONDENT_REQUEST_INSTALLMENT_PAYMENTS",
    };
  };
  export const successInstallmentPayments = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_INSTALLMENT_PAYMENTS",
      payload: data,
    };
  };
  export const errorInstallmentPayments = (data) => {
    return {
      type: "RESPONDENT_ERROR_INSTALLMENT_PAYMENTS",
      payload: data,
    };
  };
  
  export const  installmentPaymentsCall = (data) => {
    return (dispatch) => {
      API.put(`/assetDebitRes/add-and-update-installments`,data).then((res) => {
        dispatch(successInstallmentPayments(res.data));
      });
    };
  };



  export const requestDeletePeopleLive = (data) => {
    return {
      type: "RESPONDENT_REQUEST_DELETE_PEOPLE_LIVE",
    };
  };
  export const successDeletePeopleLive = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_DELETE_PEOPLE_LIVE",
      payload: data,
    };
  };
  export const errorDeletePeopleLive = (data) => {
    return {
      type: "RESPONDENT_ERROR_DELETE_PEOPLE_LIVE",
      payload: data,
    };
  };
  
  export const  deletePeopleLiveCall = (data) => {
    return (dispatch) => {
      API.post(`/assetDebitRes/delete-live-with-me`,data).then((res) => {
        dispatch(successDeletePeopleLive(res.data));
      });
    };
  };


  // delete installments

  export const requestDeleteInstallment = (data) => {
    return {
      type: "RESPONDENT_REQUEST_DELETE_INSTALLMENT",
    };
  };
  export const successDeleteInstallment = (data) => {
    return {
      type: "RESPONDENT_SUCCESS_DELETE_INSTALLMENT",
      payload: data,
    };
  };
  export const errorDeleteInstallment = (data) => {
    return {
      type: "RESPONDENT_ERROR_DELETE_INSTALLMENT",
      payload: data,
    };
  };
  
  export const  deleteInstallmentCall = (data) => {
    return (dispatch) => {
      API.post(`/assetDebitRes/delete-installments-data`,data).then((res) => {
        dispatch(successDeleteInstallment(res.data));
      });
    };
  };
